import { render, staticRenderFns } from "./quillEditor2.vue?vue&type=template&id=031b8c90&"
import script from "./quillEditor2.vue?vue&type=script&lang=js&"
export * from "./quillEditor2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports